import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Table, Text } from "@pentabd/ui";

import { DeleteConfirmationModal } from "@components";
import { TableColumn } from "./TableColumn";

import { AcrType } from "@type/HRM/acr";

interface AssessmentTableProps {
  assessmentInfo: AcrType[];
  deleteACRHistory: (id: number) => void;
  performanceComment: any;
}

export const AssessmentConfidentialTable = ({
  assessmentInfo,
  deleteACRHistory,
  performanceComment,
}: AssessmentTableProps) => {
  const { t } = useTranslation();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [itemID, setItemID] = useState<number>();

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModal();
    deleteACRHistory(itemID as number);
  };

  return (
    <div className="mb-9">
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}

      <Text
        weight="semibold"
        size="lg"
        color="dark"
        className="mb-8 pb-8 d-block border-bottom"
      >
        {t("EMPLOYEE.ACR_INFO.TABLE.LABEL")}
      </Text>
      <Table
        columns={
          TableColumn(
            t,
            performanceComment,
            setIsConfirmationModalOpen,
            setItemID,
          ) as any
        }
        rows={assessmentInfo}
        // edit={{
        //   customIcon: <IconTrash01 size="20" fill="danger" />,
        //   onClick: (id) => {
        //     setIsConfirmationModalOpen(true);
        //     setItemID(id as number);
        //   },
        // }}
      />
    </div>
  );
};
